export interface CubeProps {
  items: ItemList
}

export interface MeshProps {
  items: ItemList
  onFaceClick: (index: number) => void
}

export enum ItemType {
  IMAGE,
  COUNTDOWN,
  KANDI,
}

export type Item = {
  type: ItemType
  src: string
  kandi?: {
    outline: string
    firstname: string
    lastname: string
  }
  link?: string
  targetDate?: Date
  openExternal?: boolean
}

export type ItemList = [Item, Item, Item, Item, Item, Item?]
